import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
// import { Grid, Transition } from 'semantic-ui-react'
import { Card, Grid, Transition, Placeholder } from 'semantic-ui-react';

import { AuthContext } from '../context/auth'
import PostCard from '../components/PostCard'
import PostForm from '../components/PostForm'
import { FETCH_POSTS_QUERY } from '../util/graphql'
function Home() {
    const { user } = useContext(AuthContext)

    const { loading, data } = useQuery(FETCH_POSTS_QUERY);

    return (
        <Grid columns={1} >
            {user && (
                <Grid.Column>
                    <PostForm />
                </Grid.Column>
            )}
            <Grid.Row className="page-title">

                {loading ?
                    <>
                        <div className="lds-ripple"><div></div><div></div></div>
                        <Grid columns={2}>
                            <Grid.Row>
                                <Grid.Column width={2}>
                                    <Placeholder>
                                        <Placeholder.Header image>
                                            <Placeholder.Line />
                                            <Placeholder.Line />
                                        </Placeholder.Header>
                                    </Placeholder>
                                </Grid.Column>
                                <Grid.Column width={14}>
                                    <Card fluid>
                                        <Card.Content>
                                            <Placeholder>
                                                <Placeholder.Paragraph>
                                                    <Placeholder.Line />
                                                    <Placeholder.Line />
                                                    <Placeholder.Line />
                                                    <Placeholder.Line />
                                                </Placeholder.Paragraph>
                                            </Placeholder>
                                        </Card.Content>
                                    </Card>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={2}>
                                    <Placeholder>

                                        <Placeholder.Header image>
                                            <Placeholder.Line />
                                            <Placeholder.Line />
                                        </Placeholder.Header>
                                    </Placeholder>
                                </Grid.Column>
                                <Grid.Column width={14}>
                                    <Card fluid>
                                        <Card.Content>
                                            <Placeholder>
                                                <Placeholder.Paragraph>
                                                    <Placeholder.Line />
                                                    <Placeholder.Line />
                                                    <Placeholder.Line />
                                                    <Placeholder.Line />
                                                </Placeholder.Paragraph>
                                            </Placeholder>
                                        </Card.Content>
                                    </Card>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid >
                    </>
                    : <h1>RECENT POSTS</h1>}
            </Grid.Row>
            <Grid.Row>
                {loading ? (
                    <div></div>
                ) : (
                        data ?
                            <Transition.Group>{
                                data.getPosts && data.getPosts.map(post => (
                                    <Grid.Column key={post.id} style={{ marginBottom: 20 }}>
                                        <PostCard post={post} />
                                    </Grid.Column>
                                ))}
                            </Transition.Group>
                            :
                            <p> The WebSite Is Empty , Go Make The First Post</p>
                    )}
            </Grid.Row>
        </Grid >
    )
}



export default Home;